/**
 * 优惠券接口
 * @author chenhang06
 */
import { ApiConfigs, Response } from '@schemas/service';
import {
  ICouponListData,
  ICouponListQuery,
  ICouponPopUpDataItem,
  ICouponPopupQuery,
  IReceiveCouponQuery
} from '@schemas/coupon';
import { request } from './request';

const api: ApiConfigs = {
  // 查询优惠券弹窗展示与优惠券数据
  queryCouponPopupInfo: {
    url: '/health/api/v1/coupon/queryValidCoupon',
    // url:
    // 'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/coupon/queryValidCoupon',
    method: 'POST'
  },
  // 领取优惠券
  receiveCoupon: {
    url: '/health/api/v1/coupon/receiveCoupons',
    // url:
    // 'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/coupon/receiveCoupons',
    method: 'POST'
  },
  // 获取优惠券列表信息
  getCouponData: {
    url: '/health/api/v1/coupon/queryCouponByUser',
    // url:
    // 'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/coupon/queryCouponByUser',
    method: 'GET'
  }
};

const coupon = {
  async queryCouponPopupInfo({
    activityCodeList,
    doctorId,
    showLoading,
    actionType
  }: ICouponPopupQuery) {
    try {
      const response: Response<ICouponPopUpDataItem[]> = await request(
        api.queryCouponPopupInfo,
        {},
        {
          activityCode: activityCodeList,
          doctorId,
          actionType
        },
        {
          hideGlobalLoading: !showLoading,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }
      );
      const { result } = response;
      return result || Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async receiveCoupon({ activityCode, doctorId }: IReceiveCouponQuery) {
    try {
      const response: Response = await request(
        api.receiveCoupon,
        {},
        { activityCode: [activityCode], doctorId },
        { hideGlobalLoading: false }
      );
      const { result } = response;
      return result ? (result as any) : Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getCouponData(queryData: ICouponListQuery) {
    try {
      const response: Response = await request(api.getCouponData, {
        ...queryData
      });
      const { result } = response;
      return result ? (result as ICouponListData) : Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default coupon;
